module.exports = __webpack_public_path__ + "img/9788984011670.01dbdce1.jpg";